import { useTranslation } from 'react-i18next'

import { useCartStore } from '@features/cart/model/useCartStore'

import { PRODUCT_NO_PHOTO_PATH } from '@shared/contants/product'

import styles from './styles.module.scss'

export default function GiftProducts () {
  const { t } = useTranslation('cart')
  const saleAddedPositions = useCartStore((state) => state.cartInfoData?.saleAddedPositions)

  if (!saleAddedPositions?.length) {
    return null
  }

  return (
    <div className={styles.gifts}>
      {saleAddedPositions.map((position) => {
        if (!position?.positionKey) return null

        const productId = position.productId ?? position.info?.id ?? ''
        const productName = position.info?.name ?? `${t('discount.gift')} ${productId}`

        return (
          <div className={styles.gifts__item} key={position.positionKey}>
            <div className={styles.gifts__image}>
              {position.info?.preview?.url && (
                <img
                  src={position.info.preview.url}
                  onError={(event) => {
                    event.currentTarget.src = PRODUCT_NO_PHOTO_PATH
                  }}
                  alt=""
                />
              )}
              {!position.info?.preview?.url && <span>{t('discount.gift')}</span>}
            </div>
            <div className={styles.gifts__content}>
              <div className={styles.gifts__name}>{productName}</div>
              <div className={styles.gifts__meta}>
                <span className={styles.gifts__badge}>{t('discount.gift')}</span>
                <span>{position.amount ?? 0} {t('discount.pieces')}</span>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
